import React, { useState, useEffect } from "react";
import {
  Button,
  Table,
  Modal,
  Form,
  Input,
  Select,
  Checkbox,
  Row,
  Col,
  InputNumber,
  notification,
  Card,
  Popconfirm,
} from 'antd';
import DefaultLayout from './../../components/layout/DefaultLayout';
import Header from '../../components/header';
import { UserOutlined, FileTextOutlined } from '@ant-design/icons';
import formService from "../../services/form";

import { useNavigate } from 'react-router-dom';
import dynamicFormService from "../../services/dynamicForm";


const { Option } = Select;
const { TextArea } = Input;

const fieldTypes = ['Input', 'Number', 'Textarea', 'Select', 'Multi', 'Checkbox', 'Date', 'Datetime'];
const fieldBelongsToOptions = ['SCRF', 'CRF', 'Mobile Requisition', 'Master Data Management'];
const gridSizes = ['4/1', '3/1', '1/1'];

const CustomFields = () => {
  const navigate = useNavigate();

  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [type, setType] = useState('');
  const [defaultDataType, setDefaultDataType] = useState('static');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);


  const getFormsData = async (includeDynamic = false) => {
      setLoading(true);
      try {
        const response = await formService.getForms(includeDynamic);
        if (response) {
          setData(response.data); 
          console.log("response.meta ", response);
        } else {
          console.error("API request failed:", response);
          notification.error({
            message: "Error",
            description: response?.message || "Failed to fetch cost center data.", // Display error message from API if available
          });
        }
      } catch (error) {
        console.error("Error fetching cost center data:", error);
        notification.error({
          message: "Error",
          description: error?.response.data?.message || "Something went wrong", // Access error message safely
        });
      } finally {
        setLoading(false);
      }
    };

    //   const getFormsData = async () => {
    //   setLoading(true);
    //   try {
    //     const forms = await dynamicFormService.getForms();
    //     setData(forms.map((f) => ({ ...f, key: f.id })));
    //   } catch (err) {
    //     notification.error({ message: "Failed to fetch forms" });
    //   } finally {
    //     setLoading(false);
    //   }
    // };
    useEffect(() => {
      getFormsData(true);
    }, []);



  const [customFields, setCustomFields] = useState([
    {
      key: '1',
      fieldBelongsTo: 'SCRF',
      slug: 'App\Models\Forms\SCRF',
      type: 'Select',
      order: 1,
      showOnTable: 'SCRF',
      formIdDb: 2,
    },
    {
      key: '2',
      fieldBelongsTo: 'CRF',
      slug: 'App\Models\Forms\CRF',
      type: 'Color',
      order: 2,
      showOnTable: 'CRF',
      formIdDb: 4,
    },
    {
      key: '2',
      fieldBelongsTo: 'Deployment Form',
      slug: 'App\Models\Forms\Deployment',
      type: 'Color',
      order: 2,
      showOnTable: 'Deployment Form',
      formIdDb: 3,
    },
    {
      key: '2',
      fieldBelongsTo: 'Mobile Requisition Form',
      slug: 'App\Models\Forms\MobileRequisition',
      type: 'Color',
      order: 2,
      showOnTable: 'Mobile Requisition Form',
      formIdDb: 5,
    },
    {
      key: '2',
      fieldBelongsTo: 'Master Data Management Form',
      slug: 'App\Models\Forms\MasterDataManagementForm',
      type: 'Color',
      order: 2,
      showOnTable: 'Master Data Management Form',
      formIdDb: 6,
    },
    {
      key: '2',
      fieldBelongsTo: 'SAP Access Form',
      slug: 'App\Models\Forms\SapAccessForm',
      type: 'Color',
      order: 2,
      showOnTable: 'SAP Access Form',
      formIdDb: 7,
    }
  ]);

  // const handleAdd = (values) => {
  //   const newField = {
  //     key: `${Date.now()}`,
  //     ...values,
  //     showOnTable: values.showOnTable || false
  //   };
  //   setCustomFields([...customFields, newField]);
  //   setVisible(false);
  //   form.resetFields();
  // };

  const handleAdd = async (values) => {
    try {
      const response = await dynamicFormService.createForm({
        name: values.form_name,
        menu: values.menu,
        slug: values.slug,
        show_on_menu: values.showOnMenu || false,
        has_workflow: values.Workflow || false,
      });

      notification.success({ message: "Form created successfully" });
      setVisible(false);
      form.resetFields();
      getFormsData(true);
    } catch (error) {
      console.error(error);
      const msg = error?.response?.data?.message || "Failed to create form";
      notification.error({ message: msg });
    }
  };

  const handleDeleteForm = async (formId, formType) => {
    if (formType !== "dynamic") {
      notification.warning({ message: "Only dynamic forms can be deleted." });
      return;
    }

    try {
      await dynamicFormService.deleteForm(formId); // make sure you add deleteForm in service
      notification.success({ message: "Form deleted successfully" });
      setData(prev => prev.filter(f => f.id !== formId)); // remove from table
    } catch (error) {
      console.error(error);
      const msg = error?.response?.data?.message || "Failed to delete form";
      notification.error({ message: msg });
    }
  };


  const columns = [
    {
      title: 'Form',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Name on Menu',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Slug',
      dataIndex: 'slug',
      key: 'slug',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (record) => (
        <>
        {record.form_type === 'dynamic' && (
          <Popconfirm
            title="Are you sure to delete this dynamic form?"
            onConfirm={() => handleDeleteForm(record.id, record.form_type)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger style={{ marginLeft: 8 }}>Delete</Button>
          </Popconfirm>
        )}
        </>
      ),
    },
    {
    title: '',
    render: (dataIndex) => (
      <Button onClick={() => navigate(`/custom-forms-fields/form/${dataIndex.id}`)}>
        Manage Fields
      </Button>
    ),
    }
  ];

return (
  <DefaultLayout>
    <Row gutter={[24, 24]}>
      <Col span={24}>
      <Header
            icon={<FileTextOutlined />}
            title="Custom Forms & Fields"
            right={
              <>
                <Button className="btn-blue" type="primary" onClick={() => setVisible(true)}>
                  Create New Form
                </Button>
              </>
            }
          />
        {/*<Header icon={<UserOutlined />} title="Custom Fields" right={<></>} />*/}
      </Col>

      <Col span={24}>
        <Card title="Forms">

          <Table
            columns={columns}
            // dataSource={customFields}
            dataSource={data.filter((item) => item.id !== 1).map((item) => ({ ...item, key: item.id }))}
            pagination={false}
            bordered
          />
        </Card>

        <Modal
          title="Create a new Form"
          visible={visible}
          onCancel={() => setVisible(false)}
          onOk={() => form.submit()}
          width={800}
          destroyOnClose
        >
          <Form form={form} layout="vertical" onFinish={handleAdd}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Form Name" name="form_name" rules={[{ required: true }]}>
                  <Input placeholder="Enter form name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Name on Menu" name="menu" rules={[{ required: true }]}>
                  <Input placeholder="Enter menu name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Slug" name="slug" rules={[{ required: false }]}>
                  <Input placeholder="Enter slug name" />
                </Form.Item>
              </Col>


              <Col span={24}>
                <Form.Item name="showOnMenu" valuePropName="checked">
                  <Checkbox>Show on Menu</Checkbox>
                </Form.Item>
                <Form.Item name="Workflow" valuePropName="checked">
                  <Checkbox>Enable Workflow</Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </Col>
    </Row>
  </DefaultLayout>
);
};

export default CustomFields;
